import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import printJS from 'print-js'
import Printd from 'printd'
import CryptoJS from 'crypto-js'
import SimpleEncrypt from 'simple-encryptor'

import {
	Validator
} from 'vee-validate'
export default {
	name: 'po',

	components: {
		Paginate,

	},
	props: ['pono1'],
	data: function() {
		return {
			// initialize form field
			isLoading: false,
			PurchaseOrderDetailsData: [],
			PurchaseOrderLoopData: [],
			clientdata: [],
			supplierdata: [],
			logoUrl: '',

			pono: '0',
			poform: {},
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin"></i> Loading...',
			warehouseid: '',
			clientid: ''
		}
	}, // end data
	model: {
		totalpricewithtax: 0,
		sgst: 0,
		cgst: 0,
		igst: 0,
		totalpricewithouttaxes: 0,

	},
	computed: {

		totalpricewithtax: function() {
			return this.PurchaseOrderLoopData.reduce(function(totalpricewithtax, item) {
				return totalpricewithtax + parseFloat(item.totalpricewithtax);
			}, 0);
		},
		sgst: function() {
			return this.PurchaseOrderLoopData.reduce(function(sgst, item) {
				return sgst + parseFloat(item.totalpricewithouttaxes) * parseFloat(item.sgstratepercent) / 100;
			}, 0);
		},
		cgst: function() {
			return this.PurchaseOrderLoopData.reduce(function(cgst, item) {
				return cgst + parseFloat(item.totalpricewithouttaxes) * parseFloat(item.cgstratepercent) / 100;
			}, 0);
		},
		igst: function() {
			return this.PurchaseOrderLoopData.reduce(function(igst, item) {
				return igst + parseFloat(item.totalpricewithouttaxes) * parseFloat(item.igstratepercent) / 100;
			}, 0);
		},
		totalpricewithouttaxes: function() {
			return this.PurchaseOrderLoopData.reduce(function(totalpricewithouttaxes, item) {
				return totalpricewithouttaxes + parseFloat(item.totalpricewithouttaxes);
			}, 0);
		},
	}, // end computed

	created: function() {
		// when a page loads,mounted() will be call
	},
	mounted() {
		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		this.getPrintPo()
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		encryptData(encData){
       return this.encryptor.encrypt(encData);
		},
		decryptData(decData){
			return this.encryptor.decrypt(decData);
		},
		print() {
			const d = new Printd();
			var buffer = '';

			var cssText = `
   body{
  -webkit-print-color-adjust:exact;
}
   table {
       border-collapse: collapse;
       margin-left:0px !important;
   }

   table, td, th {
     border-style: solid;
border-width: 1px;

margin-bottom: 10px;
border-color: rgba(0,0,255,0.25);
       padding:5px;
   }
 pre {
   color: #c7254e;
 }
 .text-right{
   text-align:right;
 }

 .clientdetails{
   margin-top:-40px;
   font-size:12px;
 }
@page {
margin-top: 20mm;
margin-bottom: 0mm;
}
 @media print {
 .text-primary th{
   background-color:rgb(226, 216, 216) !important;
   color:black !important;
   font-size:20px !important;
 }

}
`
			d.print(document.getElementById('printPoContent'), cssText);
		},
		//open new form(popup)
		getPrintPo() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			if (this.pono1.pono == 0 || this.pono1.pono == '' || !this.pono1.pono)
				this.$router.push('/purchaseOrder')
			// console.log(this.$route.query.clientid);
			this.clientid = this.pono1.clientid//decryptData(this.$route.query.clientid);
			if (!this.clientid) {
				this.$alertify.error("Unauthorised user, Please select valid client");
				return false;
			}
			var userdetail = this.getLocalUserData();
			if (userdetail) {
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
			}
			this.input = ({
				'pono': this.pono1.pono,
				'clientid': this.clientid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'searchpo',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data.clientid) {
						this.clientid = result.data.data.clientid;
						this.input = ({
							'pono': this.pono1.pono,
							//'warehouseid': this.warehouseid,
							'clientid': result.data.data.clientid
						})
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'getPoAllDetails',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then(result => {
								if (result.data.length == 0)
									this.$router.push('/purchaseOrder');
								this.PurchaseOrderDetailsData = result.data.podata[0];
								this.PurchaseOrderLoopData = result.data.podata;
								this.clientdata = result.data.clientdata;
								this.supplierdata = result.data.supplierdata[0];
							}, error => {
								console.error(error);
							})
					} else {
						this.$alertify.error("Invalid PO");
					}
				});
		},
		getScore(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		},
		printPurchaseOrder() {
			printJS({
				printable: 'printPoContent',
				type: 'html',
				onLoadingStart: this.onLoadingStart,
				onLoadingEnd: this.onLoadingEnd
			});
		},
		onLoadingStart() {
			this.loading = true;
		},
		onLoadingEnd() {
			this.loading = false;
		},
		getLocalUserData() {
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			return userdetail;
		},
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/purchaseOrder/printpo.component.js